module.exports = __webpack_public_path__ + "static/mat1630_compilado-747abf5670f89df8a8a39f64c6f81147.pdf";